var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrdaLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 960.46863 408.87867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:silver;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{clip-path:url(#clip-path-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "346.419 41.596 346.419 408.879 221.738 367.318 221.738 0.035 346.419 41.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.506 34.762 117.506 117.279 221.754 82.529 221.754 0.013 117.506 34.762"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "159.91 130.731 159.91 346.055 70.457 316.237 70.457 100.914 159.91 130.731"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 124.366 0 272.449 70.471 248.958 70.471 100.876 0 124.366"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_20",
    "data-name": "font 13 20",
    viewBox: "0 0 0.585 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.441.339a.18193.18193,0,0,1,.106.06A.1682.1682,0,0,1,.585.513.162.162,0,0,1,.518.652.332.332,0,0,1,.322.7H0V0H.302A.30153.30153,0,0,1,.483.047.15447.15447,0,0,1,.548.18.167.167,0,0,1,.519.279a.169.169,0,0,1-.078.06M.074.061V.315H.297A.22774.22774,0,0,0,.428.283.10976.10976,0,0,0,.474.188.10718.10718,0,0,0,.428.094.22239.22239,0,0,0,.297.061H.074M.321.639A.25736.25736,0,0,0,.463.607a.11164.11164,0,0,0,.048-.1q0-.131-.19-.131H.074V.639Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_ab",
    "data-name": "font 13 ab",
    viewBox: "0 0 0.559 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.478.7.318.475A.50711.50711,0,0,1,.262.478H.074V.7H0V0H.262a.31617.31617,0,0,1,.21.064A.21778.21778,0,0,1,.548.24.22782.22782,0,0,1,.506.379.22839.22839,0,0,1,.388.46L.559.7H.478M.26.415A.2418.2418,0,0,0,.419.369.1589.1589,0,0,0,.474.24.15827.15827,0,0,0,.419.11.2418.2418,0,0,0,.26.064H.074V.415Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_28",
    "data-name": "font 13 28",
    viewBox: "0 0 0.66 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H.285A.41269.41269,0,0,1,.481.045.32031.32031,0,0,1,.613.169.34722.34722,0,0,1,.66.35.35253.35253,0,0,1,.613.532.32908.32908,0,0,1,.481.656.42043.42043,0,0,1,.285.7H0V0M.281.636A.34332.34332,0,0,0,.442.6.26963.26963,0,0,0,.549.499.28974.28974,0,0,0,.587.35.2844.2844,0,0,0,.549.202.26078.26078,0,0,0,.442.101.33563.33563,0,0,0,.281.064H.074V.636Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_4",
    "data-name": "font 13 4",
    viewBox: "0 0 0.713 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.551.513H.161L.077.7H0L.32,0H.393l.32.7H.635L.551.513M.524.453.356.077.188.453Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_a8",
    "data-name": "font 13 a8",
    viewBox: "0 0 0.548 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.262,0a.31617.31617,0,0,1,.21.064A.21778.21778,0,0,1,.548.24.21778.21778,0,0,1,.472.416a.3196.3196,0,0,1-.21.063H.074V.7H0V0H.262M.26.414A.2456.2456,0,0,0,.419.369.1589.1589,0,0,0,.474.24.15827.15827,0,0,0,.419.11.2418.2418,0,0,0,.26.064H.074v.35Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_85",
    "data-name": "font 13 85",
    viewBox: "0 0 0.735 0.712"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.368.712A.3906.3906,0,0,1,.179.666.34785.34785,0,0,1,.047.538.356.356,0,0,1,0,.356.356.356,0,0,1,.047.174.34061.34061,0,0,1,.179.047.384.384,0,0,1,.368,0,.37916.37916,0,0,1,.555.046.33843.33843,0,0,1,.687.174.3502.3502,0,0,1,.735.356.35553.35553,0,0,1,.687.539.34061.34061,0,0,1,.555.666.37916.37916,0,0,1,.368.712m0-.066A.305.305,0,0,0,.518.609.27594.27594,0,0,0,.623.505.29673.29673,0,0,0,.661.356.29125.29125,0,0,0,.623.208.26691.26691,0,0,0,.518.104.29871.29871,0,0,0,.368.066.30425.30425,0,0,0,.217.104.27387.27387,0,0,0,.111.208.29125.29125,0,0,0,.073.356.29673.29673,0,0,0,.111.505.28336.28336,0,0,0,.217.609.3107.3107,0,0,0,.368.646Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_68",
    "data-name": "font 13 68",
    viewBox: "0 0 0.398 0.706"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.194.706A.24088.24088,0,0,1,.083.68.21629.21629,0,0,1,0,.606L.044.556A.17537.17537,0,0,0,.195.642q.13,0,.13-.154V.064H.069V0H.398V.485A.236.236,0,0,1,.346.651.19734.19734,0,0,1,.194.706Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_30",
    "data-name": "font 13 30",
    viewBox: "0 0 0.495 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.495.636V.7H0V0H.48V.064H.074V.313H.436V.376H.074v.26Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_6b",
    "data-name": "font 13 6b",
    viewBox: "0 0 0.591 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.217.371.074.516V.7H0V0H.074V.423L.485,0H.57L.267.317.591.7H.503Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "font_13_c1",
    "data-name": "font 13 c1",
    viewBox: "0 0 0.566 0.7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.246.064H0V0H.566V.064H.32V.7H.246Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.41876.03535v408.621H221.73823V.03535Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.50586,117.27869V0H221.75359V117.27869Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.90994,100.91352V346.2116H70.45651V100.91352Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,272.44874v-171.498H70.4711v171.498Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("use", {
    width: 0.585,
    height: 0.7,
    transform: "translate(387.98117 115.52582) scale(197.14581)",
    xlinkHref: "#font_13_20"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.559,
    height: 0.7,
    transform: "translate(536.62125 115.52582) scale(197.14581)",
    xlinkHref: "#font_13_ab"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.66,
    height: 0.7,
    transform: "translate(679.15018 115.52582) scale(197.14581)",
    xlinkHref: "#font_13_28"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.713,
    height: 0.7,
    transform: "translate(819.90366 115.52582) scale(197.14581)",
    xlinkHref: "#font_13_4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-1-2",
    "data-name": "Layer-1"
  }, /*#__PURE__*/React.createElement("use", {
    width: 0.548,
    height: 0.7,
    transform: "translate(403.56372 303.1301) scale(89.5625)",
    xlinkHref: "#font_13_a8"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.559,
    height: 0.7,
    transform: "translate(487.8353 303.1301) scale(89.5625)",
    xlinkHref: "#font_13_ab"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.735,
    height: 0.712,
    transform: "translate(567.00168 302.59271) scale(89.5625)",
    xlinkHref: "#font_13_85"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.398,
    height: 0.706,
    transform: "translate(657.00388 303.13008) scale(89.5625)",
    xlinkHref: "#font_13_68"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.495,
    height: 0.7,
    transform: "translate(732.50082 303.1301) scale(89.5625)",
    xlinkHref: "#font_13_30"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.591,
    height: 0.7,
    transform: "translate(812.38431 303.1301) scale(89.5625)",
    xlinkHref: "#font_13_6b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 0.566,
    height: 0.7,
    transform: "translate(886.17715 303.1301) scale(89.5625)",
    xlinkHref: "#font_13_c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrdaLogoDark);
export default __webpack_public_path__ + "static/media/brda_logo_dark.524ed2f3ce2f4649436eaf3e1d783b9c.svg";
export { ForwardRef as ReactComponent };